import ui from "./_ui";
import error from "./_error";
import language from "./_language";
import message from "./_message";
import title from "./_title";
import tooltips from "./_tooltips";
import m from "./_m";

export default {
  ui: ui,
  error: error,
  language: language,
  message: message,
  title: title,
  tooltips: tooltips,
  m: m
};
